import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import { FaPhoneAlt, FaWhatsapp, FaFacebookF, FaUser } from "react-icons/fa";
import { BASE_URL } from "../../../Components/Base_url/Base_Url";
import "./team.css";

function Team() {
    const [team, setTeam] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetch(`${BASE_URL}/team/`)
            .then((res) => res.json())
            .then((data) => {
                setTeam(data.data || []);
            })
            .catch((err) => console.error("Error fetching team:", err))
            .finally(() => setLoading(false));
    }, []);

    // Slider settings
    const sliderSettings = {
        dots: true,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 3000,
        speed: 800,
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: true,
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 3,
                }
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 576,
                settings: {
                    slidesToShow: 1,
                    arrows: false
                }
            }
        ]
    };

    return (
        <div>
            <section className="team-section section-padding">
                <div className="container">
                    <div className="section-title text-center mb-5">
                        <h2 className="display-4 fw-bold text-dark">Meet Our Team</h2>
                        <p className="lead text-muted">The talented people behind our success</p>
                    </div>

                    {loading ? (
                        <div className="text-center py-5">
                            <div className="spinner-border text-warning" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                        </div>
                    ) : team.length === 0 ? (
                        <div className="text-center py-5">
                            <p className="text-muted">No team members found.</p>
                        </div>
                    ) : (
                        <Slider {...sliderSettings} className="team-slider">
                            {team.map((member) => (
                                <div key={member.Team_id} className="px-3">
                                    <div className="team-member-card">
                                        <div className="member-image-container">
                                            <div className="member-image">
                                                <img
                                                    src={
                                                        member.Team_Image
                                                            ? `${BASE_URL}${member.Team_Image}`
                                                            : "/img/Call_for_cabs_img/user_image.jpg"
                                                    }
                                                    alt={member.Team_Name}
                                                    onError={(e) => {
                                                        e.target.src = "/img/Call_for_cabs_img/user_image.jpg";
                                                    }}
                                                />
                                                <div className="image-overlay"></div>
                                            </div>
                                        </div>
                                        <div className="member-info text-center">
                                            <h3 className="member-name">{member.Team_Name}</h3>
                                            <span className="member-designation">{member.Team_Designation}</span>
                                            <div className="member-social">
                                                {member.Mobile_Number && (
                                                    <a href={`tel:${member.Mobile_Number}`} className="social-icon phone">
                                                        <FaPhoneAlt />
                                                    </a>
                                                )}
                                                {member.Whatsapp && (
                                                    <a
                                                        href={`https://wa.me/${member.Whatsapp}`}
                                                        target="_blank"
                                                        rel="noreferrer"
                                                        className="social-icon whatsapp"
                                                    >
                                                        <FaWhatsapp />
                                                    </a>
                                                )}
                                                {member.Facebook && (
                                                    <a
                                                        href={member.Facebook}
                                                        target="_blank"
                                                        rel="noreferrer"
                                                        className="social-icon facebook"
                                                    >
                                                        <FaFacebookF />
                                                    </a>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </Slider>
                    )}
                </div>
            </section>
        </div>
    );
}

export default Team;